(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-print-artwork-upload"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.dt-artwork-fields[data-custom-print-min-quantity]';
    const feeSelector = '.dt-artwork-fields[data-artwork-fee-variant-id]';

    const getQuantityInput = (block) => {
      const formId = block.dataset.productFormId;
      const form = formId ? document.getElementById(formId) : null;
      const escapedFormId = window.CSS && CSS.escape && formId ? CSS.escape(formId) : formId;
      const formInput = form ? form.querySelector('input[name="quantity"]') : null;
      const linkedInput = escapedFormId
        ? document.querySelector(`input[name="quantity"][form="${escapedFormId}"]`)
        : null;

      return formInput || linkedInput || document.querySelector('input[name="quantity"]');
    };

    const clampQuantity = (block) => {
      const minimum = Number(block.dataset.customPrintMinQuantity || 5);
      const input = getQuantityInput(block);

      if (!input) return;

      input.min = String(minimum);
      input.step = input.step || '1';

      const currentValue = Number(input.value || 0);

      if (!input.value || currentValue < minimum) {
        input.value = String(minimum);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    const clampAll = () => {
      document.querySelectorAll(selector).forEach(clampQuantity);
    };

    const getBlockForForm = (form) => {
      if (!form || !form.id) return null;
      const escapedFormId = window.CSS && CSS.escape ? CSS.escape(form.id) : form.id;
      return document.querySelector(`${feeSelector}[data-product-form-id="${escapedFormId}"]`);
    };

    const syncArtworkFeeChoice = (block) => {
      const feeCheckbox = block.querySelector('[data-artwork-fee-checkbox]');
      const sameArtworkCheckbox = block.querySelector('[data-same-artwork-checkbox]');
      const fileInputs = Array.from(block.querySelectorAll('[data-artwork-upload-input]'));
      const hasNewUpload = fileInputs.some((input) => input.files && input.files.length > 0);

      if (!feeCheckbox) return;

      if (hasNewUpload) {
        feeCheckbox.checked = true;
      }

      if (sameArtworkCheckbox && sameArtworkCheckbox.checked && !hasNewUpload) {
        feeCheckbox.checked = false;
      }
    };

    const syncAllArtworkFeeChoices = () => {
      document.querySelectorAll(feeSelector).forEach(syncArtworkFeeChoice);
    };

    const cartHasArtworkFee = async (variantId) => {
      const response = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) throw new Error('Could not read cart.');
      const cart = await response.json();
      return Array.isArray(cart.items) && cart.items.some((item) => Number(item.variant_id) === Number(variantId));
    };

    const addArtworkFeeToCart = async (block) => {
      const variantId = Number(block.dataset.artworkFeeVariantId);
      if (!variantId) return;

      const alreadyInCart = await cartHasArtworkFee(variantId);
      if (alreadyInCart) return;

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                'Fee for': block.dataset.productTitle || 'Custom print order',
              },
            },
          ],
        }),
      });

      if (!response.ok) throw new Error('Could not add artwork setup fee.');
    };

    const continueSubmit = (form, submitter) => {
      form.dataset.customPrintArtworkFeeReady = 'true';

      if (form.requestSubmit) {
        form.requestSubmit(submitter || undefined);
        return;
      }

      HTMLFormElement.prototype.submit.call(form);
    };

    document.addEventListener('DOMContentLoaded', clampAll);
    document.addEventListener('DOMContentLoaded', syncAllArtworkFeeChoices);
    document.addEventListener('shopify:section:load', clampAll);
    document.addEventListener('shopify:section:load', syncAllArtworkFeeChoices);
    document.addEventListener(
      'click',
      () => {
        requestAnimationFrame(clampAll);
      },
      true
    );
    const handleQuantityEdit = (event) => {
      if (event.target && event.target.matches('input[name="quantity"]')) {
        requestAnimationFrame(clampAll);
      }
    };

    document.addEventListener('input', handleQuantityEdit);
    document.addEventListener('change', handleQuantityEdit);
    document.addEventListener('change', (event) => {
      const field = event.target;
      if (!field || !field.matches('[data-artwork-upload-input], [data-same-artwork-checkbox], [data-artwork-fee-checkbox]')) {
        return;
      }

      const block = field.closest(feeSelector);
      if (block) syncArtworkFeeChoice(block);
    });
    document.addEventListener('focusout', handleQuantityEdit);
    document.addEventListener('submit', (event) => {
      if (event.target && event.target.matches('form[action*="/cart/add"]')) {
        clampAll();
      }
    });
    document.addEventListener(
      'submit',
      async (event) => {
        const form = event.target;
        if (!form || !form.matches('form[action*="/cart/add"]')) return;

        const block = getBlockForForm(form);
        if (!block) return;

        if (form.dataset.customPrintArtworkFeeReady === 'true') {
          delete form.dataset.customPrintArtworkFeeReady;
          return;
        }

        syncArtworkFeeChoice(block);

        const feeCheckbox = block.querySelector('[data-artwork-fee-checkbox]');
        if (!feeCheckbox || !feeCheckbox.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const submitter = event.submitter;
        const button = submitter && submitter.matches('button, input') ? submitter : null;
        const originalText = button ? button.textContent : '';

        if (button) {
          button.disabled = true;
          if (button.textContent) button.textContent = 'Adding setup fee...';
        }

        try {
          await addArtworkFeeToCart(block);
          continueSubmit(form, submitter);
        } catch (error) {
          console.error(error);
          alert('The artwork setup fee could not be added. Please try again before checkout.');
          if (button) {
            button.disabled = false;
            if (originalText) button.textContent = originalText;
          }
        }
      },
      true
    );

    if (document.readyState !== 'loading') {
      clampAll();
      syncAllArtworkFeeChoices();
    }

    new MutationObserver(clampAll).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
